import "core-js/modules/es.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { useState } from 'react';
import i18n from '@pureartisan/simple-i18n';
import clsx from 'clsx';
import { MdRefresh } from 'react-icons/md';
import { DEFAULT_VIEWPORT } from './../../../../../constants/map';
import { CoreButton } from './../../../../core';
import useStore from './../../store';
/**
 * Button to reset zoom and pan to default viewport settings
 */

var MapResetButton = function MapResetButton(_ref) {
  var props = _extends({}, _ref); // Generic state updates for store.
  // Accepts an object of values to update.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  });
  var resetViewport = props.resetViewport;
  var viewport = useStore(function (state) {
    return state.viewport;
  });
  var interactionsMobile = useStore(function (state) {
    return state.interactionsMobile;
  });
  var eventMapReset = useStore(function (state) {
    return state.eventMapReset;
  });

  var handleReset = function handleReset(e) {
    if (viewport.zoom !== DEFAULT_VIEWPORT.zoom || viewport.latitude !== DEFAULT_VIEWPORT.latitude || viewport.longitude !== DEFAULT_VIEWPORT.longitude) {
      resetViewport(e);
      setStoreValues({
        eventMapReset: eventMapReset + 1
      });
    }
  };

  return /*#__PURE__*/React.createElement(CoreButton, {
    color: "none",
    active: true,
    id: "map_reset_button",
    className: clsx("map-reset-btn", "mapboxgl-ctrl-icon"),
    onClick: function onClick(e) {
      handleReset(e);
    },
    label: i18n.translate("UI_MAP_RESET"),
    tooltip: !!interactionsMobile ? '' : 'left'
  }, /*#__PURE__*/React.createElement(MdRefresh, {
    className: "icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, i18n.translate("UI_MAP_RESET")));
};

export default MapResetButton;